<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">Marcações da Equipe</div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>Usuário</label>
              <select class="form-control" v-model="search.user_id">
                <option :value="user.id" v-for="user in users" :key="user.id">
                  {{ user.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>Ano</label>
              <select class="form-control" v-model="search.year">
                <option :value="year" v-for="year in years" :key="year">
                  {{ year }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>Mês</label>
              <select class="form-control" v-model="search.month">
                <option :value="month" v-for="month in months" :key="month">
                  {{ monthNames[month] }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label>Ação</label>
              <button
                class="btn btn-block btn-info"
                @click="searchChecks"
                :disabled="!search.user_id"
              >
                Buscar
              </button>
            </div>
          </div>
        </div>

        <div class="row highlight" v-if="loaded">
          <div class="col-md">
            <div class="card">
              <div class="card-body position-relative overflow-hidden">
                <div class="card-small-info">
                  <strong>Banco de Horas Manual</strong>
                </div>
                <div class="card-small-info">(M)</div>
                <div class="card-value-info">{{ bank.bank_legacy }}</div>
                <i class="fas fa-clock card-icon"></i>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="card">
              <div class="card-body position-relative overflow-hidden">
                <div class="card-small-info">
                  <strong>Banco de Horas Fechado</strong>
                </div>
                <div class="card-small-info">(A)</div>
                <div class="card-value-info">{{ bank.bank_a }}</div>
                <i class="fas fa-clock card-icon"></i>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="card">
              <div class="card-body position-relative overflow-hidden">
                <div class="card-small-info">
                  <strong>Saldo Banco Atual</strong>
                </div>
                <div class="card-small-info">(B)</div>
                <div class="card-value-info">{{ bank.bank_balance }}</div>
                <i class="fas fa-clock card-icon"></i>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="card">
              <div class="card-body position-relative overflow-hidden">
                <div class="card-small-info">
                  <strong>Banco de Horas Aberto</strong>
                  <small>(Mês Corrente)</small>
                </div>
                <div class="card-small-info">(B)</div>
                <div class="card-value-info">{{ bank.bank_b }}</div>
                <i class="fas fa-clock card-icon"></i>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="card">
              <div class="card-body position-relative overflow-hidden">
                <div class="card-small-info">
                  <strong>Banco de Horas Total</strong>
                </div>
                <div class="card-small-info">(C) = (M) + (A) + (B)</div>
                <div class="card-value-info">{{ bank.bank_c }}</div>
                <i class="fas fa-clock card-icon"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <table class="table table-hover">
              <thead>
                <th>Data</th>
                <th>Entrada</th>
                <th>Almoço</th>
                <th>Volta Almoço</th>
                <th>Saída</th>
                <th>Total</th>
                <th>Diferença</th>
              </thead>
              <tbody>
                <tr v-for="(check, index) in checks" :key="index">
                  <td>{{ formatDate(index) }}</td>
                  <td
                    :class="[
                      { 'text-blue': check[0] && check[0].check_request_id },
                      { 'text-green': check[0] && check[0].remote },
                      { 'text-purple': check[0] && check[0].manual },
                    ]"
                  >
                    <button
                      class="btn btn-sm btn-danger"
                      v-if="check[0]"
                      @click="deleteCheck(check[0].id)"
                    >
                      <i class="far fa-trash-alt"></i>
                      Deletar
                    </button>
                    {{ check[0] ? format(check[0].created_at) : "" }}
                  </td>
                  <td
                    :class="[
                      { 'text-blue': check[1] && check[1].check_request_id },
                      { 'text-green': check[1] && check[1].remote },
                      { 'text-purple': check[1] && check[1].manual },
                    ]"
                  >
                    <button
                      class="btn btn-sm btn-danger"
                      v-if="check[1]"
                      @click="deleteCheck(check[1].id)"
                    >
                      <i class="far fa-trash-alt"></i>
                      Deletar
                    </button>
                    {{ check[1] ? format(check[1].created_at) : "" }}
                  </td>
                  <td
                    :class="[
                      { 'text-blue': check[2] && check[2].check_request_id },
                      { 'text-green': check[2] && check[2].remote },
                      { 'text-purple': check[2] && check[2].manual },
                    ]"
                  >
                    <button
                      class="btn btn-sm btn-danger"
                      v-if="check[2]"
                      @click="deleteCheck(check[2].id)"
                    >
                      <i class="far fa-trash-alt"></i>
                      Deletar
                    </button>
                    {{ check[2] ? format(check[2].created_at) : "" }}
                  </td>
                  <td
                    :class="[
                      { 'text-blue': check[3] && check[3].check_request_id },
                      { 'text-green': check[3] && check[3].remote },
                      { 'text-purple': check[3] && check[3].manual },
                    ]"
                  >
                    <button
                      class="btn btn-sm btn-danger"
                      v-if="check[3]"
                      @click="deleteCheck(check[3].id)"
                    >
                      <i class="far fa-trash-alt"></i>
                      Deletar
                    </button>
                    {{ check[3] ? format(check[3].created_at) : "" }}
                  </td>
                  <td>{{ check[4] ? check[4] : "" }}</td>
                  <td>{{ check[6] ? check[6] : "" }}</td>
                </tr>
                <tr>
                  <td colspan="7" align="center">
                    Nenhum registro no período para o usuário selecionado.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bank: [],
      loaded: false,
      checks: [],
      users: [],
      bankOfHours: "",
      search: {
        year: parseInt(moment().year(), 10),
        month: parseInt(moment().month(), 10),
      },
      monthNames: [
        "Janeiro",
        "Fevereiro",
        "Maço",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
    };
  },
  computed: {
    years: function () {
      let lastYear = parseInt(moment().year(), 10);
      let availableYears = [];
      let firstYear = 2019;

      for (lastYear; lastYear >= firstYear; lastYear--) {
        availableYears.push(lastYear);
      }

      return availableYears;
    },
    months: function () {
      const self = this;
      let thisYear = parseInt(moment().year(), 10);
      let availableMonths = [];
      let lastMonth;

      if (self.search.year === thisYear) {
        lastMonth = parseInt(moment().month(), 10);
      } else {
        lastMonth = 11;
      }
      for (let i = 0; i <= lastMonth; i++) {
        availableMonths.push(i);
      }

      return availableMonths;
    },
  },
  methods: {
    deleteCheck(id) {
      console.log(id);
      const self = this;
      let api = self.$store.state.api + "checks/" + id;

      swal({
        title: "Voce está certo disso?",
        text: "a exclusão do ponto remoto não pode ser desfeita!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, deletar!",
        showLoaderOnConfirm: true,
        buttons: {
          confirm: {
            text: "Sim, deletar!",
            value: "confirm",
            className: "btn-danger",
          },
          catch: {
            text: "Cancelar",
            value: "cancel",
          },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            swal("Cancelado", "O ponto remoto não foi excluido", "info");
            break;

          case "confirm":
            self.$http
              .delete(api)
              .then((response) => {
                self.$message(
                  "Sucesso",
                  "Ponto Remoto deletado com sucesso",
                  "success"
                );
                self.searchChecks();
                self.loading = false;
              })
              .catch((error) => {
                self.$message(null, error.response.data, "error");
                self.loading = false;
              });
            break;
        }
      });
    },

    formatDate: function (date) {
      return moment(date).format("DD/MM/YYYY");
    },
    format: function (date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
    searchChecks: function () {
      const self = this;
      const api =
        this.$store.state.api +
        "checks/myChecks?year=" +
        self.search.year +
        "&month=" +
        self.search.month +
        "&user_id=" +
        self.search.user_id;

      self.$http
        .get(api)
        .then((response) => {
          self.checks = response.data.organizedChecks;
          self.bankOfHours = response.data.bankOfHours;
          self.getEntity(self.search.user_id);
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getUsers: function () {
      const self = this;
      const api = this.$store.state.api + "users/active";

      self.$http
        .get(api)
        .then((response) => {
          self.users = response.data;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getEntity: function (obj) {
      let self = this;
      let id = self.$route.params.id;
      let api = self.$store.state.api + "point-mirror/dashboard";

      self.$http
        .post(api, { user_id: obj })
        .then((response) => {
          self.bank = response.data;
          self.loaded = true;
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    self.getUsers();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Check/TeamChecks.vue